<template><div><h1>VUX 是否支持 weex</h1>
<p>不支持，也没有计划支持。</p>
</div></template><script>
export default {
  head: {"title":"VUX 是否支持 weex | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// does-vux-support-weex-44.vue?2cca28fa